// extracted by mini-css-extract-plugin
module.exports = {"container":"My","productName":"Ny","modal":"Oy","dimensions":"Py","recipientEmail":"Qy","lowStock":"Ry","recommendedFit":"Sy"};